import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RenderedService } from '../../rendered.service';
import { ActivatedRoute } from '@angular/router';
import { SearchModalComponent } from '@scaffold/editor/controls/search-modal/search-modal.component';
import { ViewUpdateService } from '@scaffold/services/view-update.service';
import { CourseService } from '@scaffold/services/course.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import {
  ScaffoldDialogService,
  ScaffoldDialogRef,
} from '@app/framework/dialog/scaffold-dialog.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslationService } from '@services/translation.service';

@Component({
    selector: 'scaffold-data-link-count',
    templateUrl: './data-link-count.component.html',
    styleUrls: [
        '../../rendered.component.scss',
        './data-link-count.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
/**
 * @fileoverview this component displays a link count and allows linking data items of a specific type
 */
export class DataLinkCountComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  dialogRef: ScaffoldDialogRef;
  public destroy$: Subject<boolean> = new Subject<boolean>();
  changeDetection;
  listChangeDetection;

  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private viewUpdate: ViewUpdateService,
    public dialog: ScaffoldDialogService,
    private route: ActivatedRoute,
    private courseService: CourseService,
    private translationService: TranslationService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(trigger => {
        this.cdr.detectChanges();
      });

    this.viewUpdate
      .registerListUpdate()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if (data && this.item.toload_type === data.type) {
          console.log(this.item);
          if (data.hasOwnProperty('removed')) {
            let index = -1;
            if (
              (data.list_type === 'link' && this.info.id == data.parent_id) ||
              data.list_type === 'list'
            ) {
              this.info.links.forEach((item, i) => {
                console.log(item.linked_id, data.removed);
                if (item.linked_id == data.removed) {
                  index = i;
                }
              });
              if (index >= 0) {
                this.info.links.splice(index, 1);
                this.renderedService.triggerUpdate('item removed');
              }
              console.log(this.info);
            }
          }
          if (data.hasOwnProperty('added')) {
            if (data.list_type === 'link' && this.info.id == data.parent_id) {
              this.courseService
                .get(
                  data.added.type +
                    '/' +
                    data.added.id +
                    '?mode=' +
                    (this.item.toload_mode || 'list')
                )
                .subscribe(co => {
                  if (co.push) {
                    co = co[0];
                  }
                  if (co.listItems) {
                    co = co.listItems[0];
                  }
                  co.link_id = data.added.link_id;
                  co.link_parent = this.info.id;
                  co.link_parent_type = this.info.type;
                  this.info.links.push({
                    linked_id: co.id,
                    type: co.type,
                    title: co.title,
                  });
                  this.redraw();
                });
            }
          }
        }
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  linkCount() {
    let count = 0;
    if (this.info && this.info.links) {
      this.info.links.forEach(link => {
        if (link.type === this.item.toload_type) count++;
      });
    }
    return count;
  }

  getContext() {
    console.log('CONTEXT: ' + this.item.parent_context);
    let context;
    if (this.item.parent_context == 'specified') {
      if (this.item.specified_type && this.item.value)
        context = { type: this.item.specified_type, id: this.item.value };
      else context = null;
    } else if (this.item.parent_context == 'all') {
      context = null;
    } else {
      context = { type: 'courses', id: this.courseService.id };
      if (this.item.get_all) {
        context.get_all = true;
      }
    }
    return context;
  }

  openSearch(selectedItem, context, allow_multiple?): void {
    console.log(selectedItem);
    let translatedLabel = '';
    if (this.item?.translation_key) {
      translatedLabel = this.translationService.getTranslatedContent(
        this.item.translation_key
      );
      translatedLabel = !this.item.text_transform
        ? translatedLabel
        : this.translationService.transform(
            translatedLabel,
            this.item.translation_key
          );
    }
    let settings: any = {
      context: {
        data: {
          selectedItem: selectedItem,
          currentValue: this.item.value,
          type: this.item.type,
          search_type: this.item.toload_type,
          search_mode: this.item.search_mode || 'list',
          context: context,
          route: this.route,
          allow_multiple: allow_multiple,
          window_title: translatedLabel
            ? translatedLabel
            : this.item.search_title && this.item.search_title.length > 0
              ? this.item.search_title
              : 'Select Items to Link' +
                (selectedItem.title ? ' to ' + selectedItem.title : ''),
          horizontal_list: this.item.horizontal_list,
          hide_search: this.item.hide_search,
          filter: this.item.filter_search,
          params: { param: this.item.param, req_value: this.item.req_value },
          prevent_create: this.item.prevent_create,
          use_dynamic_headers: this.item.use_dynamic_headers,
          headers: this.item?.headers,
        },
      },
    };
    this.dialogRef = this.dialog.open(SearchModalComponent, settings);

    this.dialogRef.onClose.subscribe(result => {
      if (result && result.length > 0) {
        this.renderedService.createLink(this.item, selectedItem, result, false);
      }
    });
  }
}
